import { useEffect } from 'react';
import { FINDING_POC_UPDATED_SSE_EVENT } from '@terra/shared-contracts-findings';
import { useSSE } from '../app/providers/SseProvider';

type UseFindingPocUpdatedSSEParams = {
  findingId: string | null;
  applicationId: string | null;
  enabled: boolean;
  onPocUpdated: () => void;
};

export function useFindingPocUpdatedSSE({
  findingId,
  applicationId,
  enabled,
  onPocUpdated,
}: UseFindingPocUpdatedSSEParams): void {
  const { subscribe } = useSSE();

  useEffect(() => {
    if (!enabled || !findingId) return;

    const unsubscribe = subscribe(FINDING_POC_UPDATED_SSE_EVENT, (event) => {
      if (event.findingId !== findingId) {
        return;
      }

      if (applicationId && event.targetId !== applicationId) {
        return;
      }

      onPocUpdated();
    });

    return unsubscribe;
  }, [enabled, findingId, applicationId, subscribe, onPocUpdated]);
}
